

























import {
	defineComponent, PropType,
} from '@vue/composition-api';
import { Size, Spacing } from '@front-app/components/constants';
import { EventManagementData } from '@front-app/services/EventsApi/EventModel';
import { syncedRef } from '@front-app/util/reactivity';
import { ButtonPalettes } from '@front-app/components/buttons/palettes';
import { useAsyncStatus } from '@front-app/hooks/useAsyncStatus';
import FormSection from '@front-app/components/form/FormSection.vue';
import FormLabel from '@front-app/components/form/FormLabel.vue';
import EventTypeSelector from '@front-app/modules/event/components/EventTypeSelector.vue';
import EditEventBaseForm from './EditEventBaseForm.vue';
import { useEventAdminStore } from '../../store/EventAdmin';

export default defineComponent({
	components: {
		EditEventBaseForm,
		EventTypeSelector,
		FormSection,
		FormLabel,
	},
	props: {
		eventData: {
			type: Object as PropType<EventManagementData>,
			required: true,
		},
	},
	setup(props, ctx) {
		const selectedTypes = syncedRef(() => props.eventData.eventTypes).ref;
		const removeSelectedType = (val: string) => {
			selectedTypes.value = selectedTypes.value.filter((_) => _ !== val);
		};
		const selectEventType = (newType: string) => {
			if (selectedTypes.value.length < 3) {
				selectedTypes.value = [...selectedTypes.value, newType];
			}
		};

		const {
			track,
			isLoading: isSavingUpdates,
			isError: isErrorSavingUpdates,
			isSuccess: isSuccessSavingUpdates,
		} = useAsyncStatus();

		const saveUpdates = async () => {
			await track(useEventAdminStore().update(props.eventData.id, { eventTypes: selectedTypes.value }));

			if (isSuccessSavingUpdates.value) {
				ctx.emit('close');
			}
		};

		return {
			selectedTypes,
			removeSelectedType,
			selectEventType,
			isSavingUpdates,
			isErrorSavingUpdates,
			saveUpdates,
			// Util
			Size,
			Spacing,
			ButtonPalettes,
		};
	},
});
